
import { useQuery } from '@tanstack/react-query';
import { ENVIRONMENT_FILTERS, EnvironmentFilterData } from '../data/environment-filters';

/**
 * Hook to fetch environment prompts from static data
 */
export const useStaticEnvironmentPrompts = () => {
  return useQuery({
    queryKey: ['static-environment-prompts'],
    queryFn: async (): Promise<EnvironmentFilterData[]> => {
      // Simulate async behavior to maintain interface compatibility
      await new Promise(resolve => setTimeout(resolve, 1));
      
      return ENVIRONMENT_FILTERS.sort((a, b) => b.priority - a.priority);
    },
    staleTime: Infinity, // Static data never goes stale
    gcTime: Infinity, // Keep in cache forever
  });
};
